const BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000';

// The /admin/* routes are served by a dedicated backend stack
// (move-club-backend-admin) on its own host. When REACT_APP_ADMIN_API_URL is
// unset this falls back to the main host, so behavior is unchanged until the
// cutover (which is just a Vercel env-var change).
const ADMIN_BASE_URL =
    process.env.REACT_APP_ADMIN_API_URL || process.env.REACT_APP_API_URL || 'http://localhost:4000';

export const API_CONFIG = {
    BASE_URL,
    ADMIN_BASE_URL,
    ENDPOINTS: {
        REGISTER: '/auth/register',
        ADMIN_LOGIN: '/auth/web/login',
        LOGIN_WITH_TOKEN: '/auth/login-with-token',
        GET_USERS: '/admin/users',
        GET_USER_BY_ID: '/admin/users',
        UPDATE_USER_STATUS: '/admin/users',
        REFRESH_TOKEN: '/auth/refresh',
        LOGOUT: '/auth/logout',
        GET_PLANS: '/stripe/plans',
        CREATE_ONE_TIME_PAYMENT: '/stripe/payment/one-time',
        VERIFY_FREE_BAND_CODE: '/free-band/verify-code',
        CREATE_FREE_BAND_ORDER: '/free-band/order',
        GET_FREE_BAND_ORDERS: '/admin/free-band/orders',
        GET_APP_FEEDBACK: '/admin/app-feedback',
        GET_WINNER_CELEBRATION_REVIEWS: '/admin/winner-celebration-reviews',
        GET_UGC_SUBMISSIONS: '/admin/ugc-submissions',
        GET_REFERRALS: '/admin/referrals',
    },
    TIMEOUT: 10000
};

// Build a full URL for an API path, routing /admin/* to the admin host and
// everything else to the main host.
export const apiUrl = (path: string): string =>
    `${path.startsWith('/admin/') ? ADMIN_BASE_URL : BASE_URL}${path}`;